/** ID виджета в DOM */
export const IFRAME_ID = 'smartbot-live-chat-iframe';

/** ID Widget элемента в DOM */
export const WIDGET_ID = 'widget';

/** URL iframe приложения виджета */
const WIDGET_URL_TEMPLATE = '__WIDGET_URL_TEMPLATE__';

const isProd = process.env.NODE_ENV === 'production';

export const WIDGET_URL = isProd ? WIDGET_URL_TEMPLATE : process.env.WIDGET_URL;

/** Точка переключения mobile/desktop layout (px) */
export const MOBILE_BREAKPOINT = 450;

/**
 * Внутренний отступ виджета внутри iframe, резервирующий пространство для box-shadow.
 * Используется для компенсации позиции iframe: iframe сдвигается ближе к краю viewport
 * на эту величину, чтобы визуальный край виджета совпадал с пользовательским offset.
 */
export const WIDGET_SHADOW_MARGIN = 16;

/** Название параметра initToken в URL */
export const INIT_TOKEN_PARAM = 'initToken';

/** Длительность анимации открытия/закрытия виджета (ms) */
export const WIDGET_ANIMATION_DURATION_MS = 300;
